import React, { useEffect, useState } from 'react'
import { AccessTime, CalendarToday, CheckOutlined, Close, LocationOnOutlined, Payment, PersonOutlineOutlined } from "@mui/icons-material";
import { Avatar, Box, Button, Chip, Grid, Table, TableBody, TableCell, TableHead, TableRow, Typography, useMediaQuery, useTheme } from "@mui/material";
import { avatarColors } from "../../../Component/AvtarColors/AvtarColors";
import { paymentStatusColor } from "../../../Component/PaymentStatusColor/paymnetStatusColor";
import { ApiGetOrderbyId, ApiGetOrders, ApiUpdateOrderStatus } from '../../../Core/Apicall';
import { Orders } from '../../../types/Orders';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import dayjs from 'dayjs';
import { orderStatusColors } from '../../../Component/OrderStatusColors/orderStatusColors';

interface OrderDetailsProps {
    orderId?: number;
    setRefresh?: () => void;
}
function OrderDetails({ orderId: parentOrderId, setRefresh }: OrderDetailsProps) {
    const { orderId: routeOrderId } = useParams();
    const orderId = parentOrderId || routeOrderId;
    const [order, setOrder] = useState<Orders>()

    const getAvatarColor = (name: string = "") => {
        let total = 0;

        for (let i = 0; i < name.length; i++) {
            total += name.charCodeAt(i);
        }
        const index = total % avatarColors.length;

        return avatarColors[index];
    };

    const GetOrders = async () => {
        try {
            const data = `?orderId=${orderId}`
            const res = await ApiGetOrderbyId(data)
            if (res?.status) {
                setOrder(res?.data)
            }
        } catch (error: any) {
            toast.error(error?.message || "Something went worng")
        }
    }

    useEffect(() => {
        orderId && GetOrders()
    }, [orderId])

    const UpdateOrderStatus = async (status: ("APPROVED" | "REJECTED")) => {
        try {
            const params = `?orderId=${orderId}`
            const data = {
                status: status,
                ...(status === "REJECTED" && { rejectionReason: "Not Needed" })

            }
            const res = await ApiUpdateOrderStatus(params, data)
            if (res?.status) {
                setRefresh?.();
            }
        } catch (error: any) {
            toast.error(error?.message || "Something went wrong")
        }
    }

    return order ? (
        <Box className='d-flex flex-column p-lg-3 p-xl-4 p-2'>
            <Box className='d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between gap-3'>
                <Box>
                    <Box className='d-flex align-items-center gap-3'>
                        <Typography variant='h5' className='fw-bold'>Order {order?.orderNumber}</Typography>
                        <Chip
                            label={order?.status}
                            size="small"
                            sx={{
                                backgroundColor: orderStatusColors[order?.status?.toUpperCase()].bg,
                                color: orderStatusColors[order?.status?.toUpperCase()].color,
                                fontWeight: 600,
                                borderRadius: "20px",
                                minWidth: 95,
                            }}
                        />
                    </Box>
                    <Typography variant='caption'>Placed on {dayjs(order?.created_at)?.format("DD MMM YYYY")} at {dayjs(order?.created_at)?.format("HH:mm a")}</Typography>
                </Box>
                {/* <Box className='d-flex align-items-stertch gap-3'>
                    <Box>
                        <Typography variant='caption'>Requested Delivery</Typography>
                        <Typography variant='body2'>02 Jun 2026</Typography>
                    </Box>
                    <Box className='border '></Box>
                    <Box>
                        <Typography variant='caption'>Payment Status</Typography>
                        <Typography variant='body2' className='text-center border-5' sx={{ width: 'fit-content', padding: '1px 8px', backgroundColor: paymentStatusColor[order?.payment_status].bg, color: paymentStatusColor[order?.payment_status].color }}>Paid</Typography>
                    </Box>
                </Box> */}

            </Box>
            <Grid container spacing={1} className='my-2 mb-3'>
                <Grid size={{ xs: 6, md: "grow" }} className='border-main card-bg  border-10 p-3'>
                    <Grid container>
                        <Grid size='grow'>
                            <Typography variant='body2' gutterBottom>Payment Status</Typography>
                            <Chip
                                label={order?.payment_status}
                                size="small"
                                sx={{
                                    backgroundColor: paymentStatusColor[order?.payment_status?.toUpperCase()].bg,
                                    color: paymentStatusColor[order?.payment_status?.toUpperCase()].color,
                                    fontWeight: 600,
                                    borderRadius: "20px",
                                    minWidth: 95,
                                }}
                            />
                        </Grid>
                        <Grid size='auto'>
                            <Box className='p-2 border-10' sx={{ bgcolor: `${paymentStatusColor[order?.payment_status?.toUpperCase()].bg} !important` }}>
                                <Payment sx={{ fontSize: '32px', color: `${paymentStatusColor[order?.payment_status?.toUpperCase()].color} !important`, }} />
                            </Box>
                        </Grid>
                        {/* <Grid size={12}>
                            <Typography variant='caption'>{order?.payment_method}</Typography>
                            <Typography variant='caption'>{order?.paymentNotes}</Typography>
                        </Grid> */}
                    </Grid>
                </Grid>
                <Grid size={{ xs: 6, md: "grow" }} className='border-main card-bg  border-10 p-3'>
                    <Grid container>
                        <Grid size='grow'>
                            <Typography variant='body2' gutterBottom>Order Status</Typography>
                            <Chip
                                label={order?.status}
                                size="small"
                                sx={{
                                    backgroundColor: orderStatusColors[order?.status?.toUpperCase()].bg,
                                    color: orderStatusColors[order?.status?.toUpperCase()].color,
                                    fontWeight: 600,
                                    borderRadius: "20px",
                                    minWidth: 95,
                                }}
                            />
                        </Grid>
                        <Grid size='auto'>
                            <Box className='p-2 border-10' sx={{ bgcolor: `${orderStatusColors[order?.status?.toUpperCase()].bg} !important` }}>
                                <AccessTime sx={{ fontSize: '32px', color: `${orderStatusColors[order?.status?.toUpperCase()].color} !important`, }} />
                            </Box>
                        </Grid>
                        {/* <Grid size={12}>
                            <Typography variant='caption'>{order?.payment_method}</Typography>
                            <Typography variant='caption'>{order?.paymentNotes}</Typography>
                        </Grid> */}
                    </Grid>
                </Grid>
                <Grid size={{ xs: 6, md: "grow" }} className='border-main card-bg  border-10 p-3'>
                    <Grid container>
                        <Grid size='grow'>
                            <Typography variant='body2' gutterBottom>Delivery Date</Typography>
                            <Typography variant='body1'>{dayjs(order?.expectedDeliveryDate)?.format("DD-MMM-YYYY")}</Typography>
                        </Grid>
                        <Grid size='auto'>
                            <Box className='p-2 border-10' sx={{ bgcolor: `${orderStatusColors["PROCESSING"].bg} !important` }}>
                                <CalendarToday sx={{ fontSize: '32px', color: `${orderStatusColors["PROCESSING"].color} !important`, }} />
                            </Box>
                        </Grid>
                        <Grid size={12}>
                            <Typography variant='caption'>{order?.payment_method}</Typography>
                            <Typography variant='caption'>{order?.paymentNotes}</Typography>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid size={{ xs: 6, md: "grow" }} className='border-main card-bg  border-10 p-3'>
                    <Grid container>
                        <Grid size='grow'>
                            <Typography variant='body2' gutterBottom>Dealer</Typography>
                            <Typography variant='body1' className='fw-bold' gutterBottom>{order?.subClient?.companyName}</Typography>

                        </Grid>
                        <Grid size='auto'>
                            <Box className='p-2 border-10 bg-second-light'>
                                <PersonOutlineOutlined className='text-main' sx={{ fontSize: '32px' }} />
                            </Box>
                        </Grid>
                        {/* <Grid size={12}>
                            <Typography variant='caption'>{order?.payment_method}</Typography>
                            <Typography variant='caption'>{order?.paymentNotes}</Typography>
                        </Grid> */}
                    </Grid>
                </Grid>
            </Grid>
            <Box sx={{ flex: 1, overflow: 'hidden' }}>
                <Box className='d-flex flex-column'>
                    <Box className='mt-2'>
                        <Typography variant='body1' className='fw-bold' gutterBottom>Order Itmes {order?.items?.length}</Typography>
                        <Box className='d-flex flex-column align-items-end justify-content-end border  bg-white border-10 overflow-hidden'>
                            <Box
                                className='w-100'
                                sx={{ overflow: 'auto' }}
                            >
                                <Table
                                    stickyHeader
                                    sx={{
                                        width: "100%",
                                        background: 'white',
                                        borderRadius: '10px'
                                        // tableLayout: "fixed",
                                    }}
                                >
                                    <TableHead>
                                        <TableRow>
                                            <TableCell
                                                sx={{
                                                    width: "auto",
                                                    position: "sticky",
                                                    top: 0,
                                                    zIndex: 2,
                                                    // backgroundColor: "white",
                                                }}
                                            >
                                                Product
                                            </TableCell>

                                            <TableCell
                                                sx={{
                                                    width: 120,
                                                    position: "sticky",
                                                    top: 0,
                                                    zIndex: 2,
                                                    backgroundColor: "background.paper",
                                                }}
                                            >
                                                Price
                                            </TableCell>

                                            <TableCell
                                                sx={{
                                                    width: 80,
                                                    position: "sticky",
                                                    top: 0,
                                                    zIndex: 2,
                                                    backgroundColor: "background.paper",
                                                }}
                                            >
                                                Qty
                                            </TableCell>

                                            <TableCell
                                                sx={{
                                                    width: 100,
                                                    position: "sticky",
                                                    top: 0,
                                                    zIndex: 2,
                                                    backgroundColor: "background.paper",
                                                }}
                                            >
                                                Tax
                                            </TableCell>

                                            <TableCell
                                                sx={{
                                                    width: 140,
                                                    position: "sticky",
                                                    top: 0,
                                                    zIndex: 2,
                                                    backgroundColor: "background.paper",
                                                }}
                                            >
                                                Total (INR)
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>

                                    <TableBody>
                                        {order?.items?.map((item) => (
                                            <TableRow key={item.variant?.variantId}>
                                                <TableCell>
                                                    <Box className="d-flex align-items-center gap-2">
                                                        <Box
                                                            component="img"
                                                            src={item?.variant?.variantImages?.find((v) => v.is_thumbnail)?.image_url || item?.variant?.variantImages?.[0]?.image_url}
                                                            sx={{
                                                                height: "32px",
                                                                width: "32px",
                                                                objectFit: "cover",
                                                            }}
                                                            className="border-main border-10"
                                                        />

                                                        <Typography
                                                            sx={{
                                                                display: "-webkit-box",
                                                                WebkitLineClamp: 2,
                                                                WebkitBoxOrient: "vertical",
                                                                overflow: "hidden",
                                                                lineHeight: 1.5,
                                                            }}
                                                            variant='body2'
                                                        >
                                                            {item?.variant?.sku}
                                                        </Typography>
                                                    </Box>
                                                </TableCell>

                                                <TableCell>₹{item?.discounted_price}</TableCell>

                                                <TableCell>{item?.quantity}</TableCell>

                                                <TableCell>18 %</TableCell>

                                                <TableCell>
                                                    {Number(item?.total)?.toLocaleString("en-IN", {
                                                        style: "currency",
                                                        currency: "INR",
                                                    })}
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </Box>
                            <Box className='d-flex flex-column gap-3 p-3' sx={{ width: { xs: "100%", md: "25%" }, height: 'fit-content' }}>
                                <Box className='d-flex align-items-center justify-content-between gap-4'>
                                    <Typography variant='body2'>Subtotal (Excl. Tax)</Typography>
                                    <Typography variant='body2'>
                                        {Number(order?.subtotal)?.toLocaleString("en-US", {
                                            style: "currency",
                                            currency: "INR",
                                        })}
                                    </Typography>
                                </Box>

                                <Box className='d-flex align-items-center justify-content-between gap-4'>
                                    <Typography variant='body2'>Tax (18%)</Typography>
                                    <Typography variant='body2'>
                                        {Number(order?.tax)?.toLocaleString("en-US", {
                                            style: "currency",
                                            currency: "INR",
                                        })}
                                    </Typography>
                                </Box>
                                <Box className='border'></Box>
                                <Box className='d-flex align-items-center justify-content-between gap-4'>
                                    <Typography variant='body2' className='fw-bold'>Total Amount</Typography>
                                    <Typography variant='body2' className='fw-bold'>
                                        {Number(order?.totalAmount)?.toLocaleString("en-US", {
                                            style: "currency",
                                            currency: "INR",
                                        })}
                                    </Typography>
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                    <Grid container spacing={1} className='my-3'>
                        <Grid size={{ xs: 12, md: 'grow' }} className='border border-10 p-3 card-bg'>
                            <Box className='d-flex align-items-center gap-1 mb-3'>
                                <PersonOutlineOutlined className='text-blue' />
                                <Typography variant='body2' className='fw-bold text-blue'>Dealer Information</Typography>
                            </Box>
                            <Box className='d-flex align-items-start gap-3'>
                                <Avatar
                                    sx={{
                                        width: 48,
                                        height: 48,
                                        bgcolor: getAvatarColor(order?.subClient?.companyName).bg,
                                        color: getAvatarColor(order?.subClient?.companyName).text,
                                        fontSize: 14,
                                        fontWeight: 700,
                                    }}
                                >
                                    {"TS"}
                                </Avatar>
                                <Box>
                                    <Typography variant='body2' className='fw-bold'>{order?.subClient?.companyName}</Typography>
                                    <Typography variant='body2'>{order?.subClient?.email}</Typography>
                                    <Typography variant='body2'>{order?.subClient?.mobile}</Typography>
                                </Box>
                            </Box>
                        </Grid>
                        <Grid size={{ xs: 12, md: 'grow' }} className='border border-10 p-3 card-bg'>
                            <Box className='d-flex align-items-center gap-1 mb-3'>
                                <LocationOnOutlined className='text-yellow' />
                                <Typography variant='body2' className='fw-bold text-yellow'>Shipping Address</Typography>
                            </Box>
                            <Typography variant='body2' sx={{ maxWidth: '300px' }}>{order?.shippingAddress?.addressLine1}{order?.shippingAddress?.addressLine2 ? `,${order?.shippingAddress?.addressLine2},`:""}{order?.shippingAddress?.city},{order?.shippingAddress?.state}-{order?.shippingAddress?.postalCode},{order?.shippingAddress?.country}</Typography>
                        </Grid>
                        {order?.status === "PENDING" && (
                            <Grid size={{ xs: 12, md: 'grow' }} className='border border-10 p-3 card-bg'>
                            <Typography variant='body2' className='fw-bold mb-3'>Approval Actions</Typography>
                            <Box className='d-flex align-items-center gap-2 justify-content-center mt-md-0'>
                                <Button className='btn-outlined-danger px-3' fullWidth onClick={() => { UpdateOrderStatus("REJECTED") }}><Close />&nbsp;Reject</Button>
                                <Button className='btn-main px-3' fullWidth onClick={() => { UpdateOrderStatus("APPROVED") }}><CheckOutlined />Approve</Button>
                            </Box>
                        </Grid>
                        )} 
                    </Grid>
                </Box>
            </Box>

        </Box>
    ) : (<></>)
}

export default OrderDetails
